import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryIcons: Record<string, string> = {
  all: 'ri-apps-line',
  action: 'ri-sword-line',
  comedy: 'ri-emotion-laugh-line',
  romance: 'ri-heart-line',
  scifi: 'ri-rocket-line',
  horror: 'ri-ghost-line',
  animation: 'ri-palette-line',
  suspense: 'ri-search-eye-line',
  war: 'ri-shield-line',
};

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            影视分类
          </h2>
          <p className="text-foreground-500 text-sm">找到你想看的类型，开启深夜观影之旅</p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-9 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-800/40 hover:bg-primary-500/10 border border-background-700/30 hover:border-primary-500/30 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-700/50 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${categoryIcons[cat.slug] || 'ri-movie-line'} text-primary-400 text-xl`}></i>
              </div>
              <span className="text-foreground-400 group-hover:text-primary-400 text-xs font-medium transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}